import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  TextFieldBuilderComponent
} from '@app/shared/components/fields/text-field-builder/text-field-builder.component';
import { ExternalLinkService } from '@services/external-link.service';

@Component({
    selector: 'link-field-builder',
    templateUrl: './link-field-builder.component.html',
    styleUrls: ['./link-field-builder.component.scss'],
    standalone: false
})
export class LinkFieldBuilderComponent extends TextFieldBuilderComponent {
  private readonly externalLinkService = inject(ExternalLinkService);

  /**
   * Show a confirmation popup before opening an external link.
   * Open the link in a new tab if the user confirms it, otherwise do nothing.
   * User can authorize the link to be opened without confirmation in the future.
   * If the link has been permanently allowed, open it directly.
   * Stop event propagation to not enter in edition mode.
   * @param event Event.
   */
  public confirmExternalLink(event: Event): void {
    event.stopPropagation();
    event.preventDefault();
    this.externalLinkService.confirmExternalLink(this.getFieldValue())
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
  }
}
